@if (subaccountConfig$ | async; as subaccountConfig) {
  @if (subaccountConfig.custom) {
    <div
      class="brand brand-subaccount"
      >
      <div>
        <img [src]="subaccountConfig.logo" class="logo" alt="" />
      </div>
    </div>
  } @else {
    <div class="brand brand-turbo">
      <img
        src="/assets/img/logo_full_white.svg"
        class="logo"
        [alt]="'l_tagline' | i18n"
        />
    </div>
  }
}

<p-menu [model]="sidebarMenuItems" class="grow"></p-menu>

<!-- ACCOUNT -->
<div class="sidebar__menu-account">
  <!-- GDPR badge -->
  @if (showGdprBadge) {
    <div
      class="sidebar__menu-gdpr-container flex items-stretch gap-2"
      (click)="openGdprSidebar()"
      >
      <div class="sidebar__menu-gdpr-img flex items-center">
        <img src="assets/img/gdpr-icon.svg" alt="GDPR compliant" />
      </div>
      <div class="flex items-center">
        <div>
          <strong>100% GDPR</strong> COMPLIANT<br>
          <small>{{'gdpr_data_location' | i18n}}. <a>{{'gdpr_see_details' | i18n}}</a></small>
        </div>
      </div>
    </div>
  }


  @if (plans | async; as plans) {
    <p-carousel
      styleClass="sidebar__menu-account-plans"
      [value]="plans"
      dir="ltr"
      [circular]="plans.length > 1"
      [showIndicators]="plans.length > 1"
      [showNavigators]="plans.length > 1"
      >
      <!-- IF PLANS -->
      <ng-template let-plan pTemplate="item">
        <h4>
          <strong
            [textContent]="'plan_' + plan.smtp_limit_interval | lowercase | i18n"
            ></strong
            ><br />
            @if (plan.smtp_limit !== -1) {
              <span>{{
                plan.smtp_limit | number : "1.0-2"
              }}</span>
            } @else {
              {{ "unlimited" | i18n }}
            }
            /
            <span
          [textContent]="
            'plan_short_' + plan.smtp_limit_interval | lowercase | i18n
          "
            ></span>
          </h4>
          <p>
            @if (plan.plan_expiration !== '0000-00-00') {
              <span class="text-sm"
                >{{ "m_validuntil" | i18n }} {{ plan.plan_expiration | date }}</span
                >
              }
              <br /><strong class="text-2xl">{{
              plan.smtp_count | number : "1.0-2"
            }}</strong>
            <br /><span class="text-sm">{{ "m_emailsentout" | i18n }}</span>
            <br /><span class="text-sm">{{ "m_of" | i18n }}</span>
            <strong>
              @if (plan.smtp_limit !== -1) {
                <span>
                  {{ plan.smtp_limit | number : "1.0-2" }}
                </span>
              } @else {
                {{ "unlimited" | i18n }}
              }
            </strong>
          </p>
        </ng-template>
        <!-- IF NO PLANS
        <ng-template>
          <h4>Your plan has been "supsended"</h4>
        </ng-template>
        -->
        @if (!isSubaccount) {
          <ng-template pTemplate="footer">
            <p-button styleClass="p-button-success" routerLink="/myaccount/upgrade">{{
              "button_add_plan" | i18n
            }}</p-button>
          </ng-template>
        }
      </p-carousel>
    }

    <!---->
    <ul class="sidebar__menu-account-shortlink">

      @if (isDev) {
        <li>
          <a (click)="openNewVersionModal()"> OPEN NEW VERSION MODAL </a>
        </li>
      }
      <li>
        <a
          (click)="openSMTPSettings()"
          title="{{ 'settings_smtp_title' | i18n }}"
          >{{ "settings_smtp_title" | i18n }}</a
          >
        </li>
        <li>
          @if (!isSubaccount) {
            <a
              (click)="openDNSSettings()"
              title="{{ 'settings_sender_title' | i18n }}"
              >{{ "settings_sender_title" | i18n }}</a
              >
            }
          </li>
          <li>
            <a
              [href]="turboSMTPApiUrl"
              title="{{ 'settings_api_title' | i18n }}"
              target="_blank"
              >{{ "settings_api_title" | i18n }}
              <i class="ms-2 pi pi-external-link"></i
              ></a>
            </li>
          </ul>
        </div>
